import * as mutationsType from './mutationsType'
export default {
  //保存用户信息
  saveUserInfo ({ commit }, userInfo) {
    commit(mutationsType.RECEIVE_USER_INFO, { userInfo })
  },
}
